import React, { useState, useEffect, useCallback } from 'react';
import { Button, message, Card, Typography, Table, Tag, Space, Tooltip, Modal, Input } from 'antd';
import { ReloadOutlined, EnvironmentOutlined, EditOutlined, DeleteOutlined, ClockCircleOutlined, PlayCircleOutlined, StopOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { apiGetMayTinhViecMoi, apiGetCongTrinhViecMoi, apiGetDuAnViecMoi, apiGetPhotocopyViecMoi, apiDeleteJob, apiUpdateStatusUser, apiPushNotiSuper, apiUpdateNoiDung } from '../services/authService';
import { socketManager } from '../utils/socket';
import dayjs from 'dayjs';

const { Text } = Typography;

const ViecDangLamComponent = () => {
    const [loading, setLoading] = useState(false);
    const [jobsData, setJobsData] = useState([]);
    const [mapModalVisible, setMapModalVisible] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [selectedJob, setSelectedJob] = useState(null);
    const [editContent, setEditContent] = useState('');

    const fetchViecDangLam = async () => {
        setLoading(true);
        try {
            console.log('=== API GET VIEC DANG LAM ===');

            // Gọi cả 4 API song song với xử lý lỗi riêng biệt
            const [mayTinhResponse, congTrinhResponse, duAnResponse, photocopyResponse] = await Promise.allSettled([
                apiGetMayTinhViecMoi(),
                apiGetCongTrinhViecMoi(),
                apiGetDuAnViecMoi(),
                apiGetPhotocopyViecMoi()
            ]);

            console.log('May Tinh Response:', mayTinhResponse);
            console.log('Cong Trinh Response:', congTrinhResponse);
            console.log('Du An Response:', duAnResponse);
            console.log('Photocopy Response:', photocopyResponse);

            // Xử lý response từ API Máy tính
            let mayTinhJobs = [];
            if (mayTinhResponse.status === 'fulfilled') {
                const data = mayTinhResponse.value;
                if (data && data.data && Array.isArray(data.data)) {
                    mayTinhJobs = data.data;
                } else if (Array.isArray(data)) {
                    mayTinhJobs = data;
                } else if (data && typeof data === 'object') {
                    mayTinhJobs = data.jobs || data.list || [];
                }
            } else {
                console.error('API Máy tính failed:', mayTinhResponse.reason);
            }

            // Xử lý response từ API Công trình
            let congTrinhJobs = [];
            if (congTrinhResponse.status === 'fulfilled') {
                const data = congTrinhResponse.value;
                if (data && data.data && Array.isArray(data.data)) {
                    congTrinhJobs = data.data;
                } else if (Array.isArray(data)) {
                    congTrinhJobs = data;
                } else if (data && typeof data === 'object') {
                    congTrinhJobs = data.jobs || data.list || [];
                }
            } else {
                console.error('API Công trình failed:', congTrinhResponse.reason);
            }

            // Xử lý response từ API Dự án
            let duAnJobs = [];
            if (duAnResponse.status === 'fulfilled') {
                const data = duAnResponse.value;
                if (data && data.data && Array.isArray(data.data)) {
                    duAnJobs = data.data;
                } else if (Array.isArray(data)) {
                    duAnJobs = data;
                } else if (data && typeof data === 'object') {
                    duAnJobs = data.jobs || data.list || [];
                }
            } else {
                console.error('API Dự án failed:', duAnResponse.reason);
            }

            // Xử lý response từ API Photocopy
            let photocopyJobs = [];
            if (photocopyResponse.status === 'fulfilled') {
                const data = photocopyResponse.value;
                if (data && data.data && Array.isArray(data.data)) {
                    photocopyJobs = data.data;
                } else if (Array.isArray(data)) {
                    photocopyJobs = data;
                } else if (data && typeof data === 'object') {
                    photocopyJobs = data.jobs || data.list || [];
                }
            } else {
                console.error('API Photocopy failed:', photocopyResponse.reason);
                // Không hiển thị lỗi cho user vì có thể API chưa có
            }

            // Kết hợp dữ liệu từ cả 4 API
            const jobsArray = [...mayTinhJobs, ...congTrinhJobs, ...duAnJobs, ...photocopyJobs];

            // Lọc chỉ lấy công việc của bộ phận Máy tính, Công trình, Dự án và Photocopy
            const filteredJobs = jobsArray.filter(job => {
                const department = job.department || job.part || '';
                return department === 'Máy tính' ||
                    department === 'Công trình' ||
                    department === 'Dự án' ||
                    department === 'Photocopy';
            });

            console.log('=== PROCESSED DATA ===');
            console.log('May Tinh jobs:', mayTinhJobs.length);
            console.log('Cong Trinh jobs:', congTrinhJobs.length);
            console.log('Du An jobs:', duAnJobs.length);
            console.log('Photocopy jobs:', photocopyJobs.length);
            console.log('Total combined jobs:', jobsArray.length);
            console.log('Filtered jobs (Máy tính, Công trình, Dự án, Photocopy):', filteredJobs.length);
            console.log('Final jobs array:', filteredJobs);

            if (filteredJobs.length > 0) {
                console.log('First filtered job:', filteredJobs[0]);
                console.log('Job structure keys:', Object.keys(filteredJobs[0]));

                // Log chi tiết từng job đã lọc
                filteredJobs.forEach((job, index) => {
                    console.log(`Filtered Job ${index + 1}:`, {
                        id: job.id,
                        user_id: job.user_id,
                        name: job.name,
                        noi_dung: job.noi_dung,
                        department: job.department,
                        status: job.status,
                        start: job.start,
                        end: job.end,
                        note: job.note,
                        toa_do: job.toa_do
                    });
                });
            }

            console.log('===============================');

            // Lưu dữ liệu đã lọc vào state
            setJobsData(filteredJobs);

            // message.success(`Đã tải ${jobsArray.length} công việc đang làm`);
        } catch (error) {
            console.log('=== API GET VIEC DANG LAM ERROR ===');
            console.log('Error:', error);
            if (error.response) {
                console.log('Error Response:', error.response.data);
                console.log('Status:', error.response.status);
            }
            console.log('=======================================');

            if (error.response) {
                message.error(`Lỗi API: ${error.response.data?.message || 'Không thể lấy dữ liệu công việc'}`);
            } else if (error.request) {
                message.error('Không thể kết nối đến server');
            } else {
                message.error('Đã xảy ra lỗi không mong muốn khi tải công việc');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleViewLocation = (record) => {
        try {
            const { toa_do, name } = record;
            if (toa_do && toa_do.length === 2) {
                const [lat, lng] = toa_do;

                // Validate coordinates
                if (isNaN(lat) || isNaN(lng)) {
                    message.error('Tọa độ không hợp lệ');
                    return;
                }

                setSelectedLocation({
                    lat: parseFloat(lat),
                    lng: parseFloat(lng),
                    name,
                    jobId: record.id,
                    content: record.noi_dung
                });
                setMapModalVisible(true);
            } else {
                message.warning('Không có thông tin vị trí');
            }
        } catch (error) {
            console.error('Error in handleViewLocation:', error);
            message.error('Có lỗi xảy ra khi mở bản đồ');
        }
    };

    const handleEditJob = (record) => {
        setSelectedJob(record);
        setEditContent(record.noi_dung);
        setEditModalVisible(true);
    };

    // Hàm sửa công việc thực tế
    const editJob = async (idJob, idUser, device_token, jobNew) => {
        const notificationType = 'edit_job';
        const customMessage = 'Nội dung công việc của bạn đã được cập nhật thay đổi!';

        try {
            // Cập nhật nội dung công việc
            const data = await apiUpdateNoiDung(idJob, jobNew);
            console.log('Job updated:', data);

            // Reload lại danh sách công việc
            fetchViecDangLam();

            // Bắn socket để app mobile cập nhật
            socketManager.emit('sendJob', { message: 'Toi da sua Job' });

            // Gửi notification nếu có device_token
            if (device_token) {
                const noti = await apiPushNotiSuper(device_token, notificationType, customMessage);
                console.log('Notification sent:', noti);
            }

            // Đóng modal và reset state
            setEditModalVisible(false);
            setSelectedJob(null);
            setEditContent('');

            message.success(`Đã cập nhật nội dung công việc ID: ${idJob} thành công!`);
        } catch (error) {
            console.error('Error updating job:', error);
            if (error.response && error.response.status !== 401 && error.response.status !== 403) {
                message.error('Lỗi! Vui lòng kiểm tra lại kết nối mạng.');
            }
        }
    };

    // Hàm xử lý submit edit với confirm dialog
    const handleSubmitEditJob = (noiDung) => {
        Modal.confirm({
            title: 'Xác nhận sửa việc',
            icon: <ExclamationCircleOutlined />,
            content: 'Bạn muốn thay đổi nội dung việc này?',
            okText: 'OK',
            cancelText: 'Hủy',
            onOk() {
                editJob(selectedJob.id, selectedJob.user_id, selectedJob.device_token, noiDung);
            },
            onCancel() {
                console.log('Cancel edit');
            },
        });
    };

    const handleSaveEdit = () => {
        if (!editContent.trim()) {
            message.error('Nội dung công việc không được để trống');
            return;
        }

        // Gọi hàm confirm trước khi thực hiện edit
        handleSubmitEditJob(editContent.trim());
    };

    // Hàm cập nhật trạng thái user
    const updateStatusUser = async (id, status) => {
        try {
            const res = await apiUpdateStatusUser(id, status);
            console.log('Updated user status:', res);
        } catch (error) {
            console.error('Error updating user status:', error);
            if (error.response && error.response.status !== 401 && error.response.status !== 403) {
                message.error('Lỗi cập nhật trạng thái user! Vui lòng kiểm tra lại kết nối mạng.');
            }
        }
    };

    // Hàm xóa công việc thực tế
    const deleteJob = async (id, user_id, device_token) => {
        const notificationType = 'delete_job';
        const customMessage = 'Công việc của bạn đã bị HỦY BỎ bởi Đội trưởng!';

        try {
            // Xóa công việc
            const data = await apiDeleteJob(id);
            console.log('Job deleted:', data);

            // Reload lại danh sách công việc
            fetchViecDangLam();

            // Cập nhật trạng thái user về 0 (không làm việc)
            updateStatusUser(user_id, 0);

            // Bắn socket để app mobile cập nhật
            socketManager.emit('sendJob', { message: 'Toi da xoa Job' });

            // Gửi notification nếu có device_token
            if (device_token) {
                const noti = await apiPushNotiSuper(device_token, notificationType, customMessage);
                console.log('Notification sent:', noti);
            }

            message.success(`Đã xóa công việc ID: ${id} thành công!`);
        } catch (error) {
            console.error('Error deleting job:', error);
            if (error.response && error.response.status !== 401 && error.response.status !== 403) {
                message.error('Lỗi! Vui lòng kiểm tra lại kết nối mạng.');
            }
        }
    };

    // Hàm xử lý xóa công việc với confirm dialog
    const handleDeleteJob = (record) => {
        Modal.confirm({
            title: 'Xác nhận xóa việc',
            icon: <ExclamationCircleOutlined />,
            content: (
                <div>
                    <p>Bạn chắc chắn muốn xóa việc này?</p>
                    <div style={{ marginTop: '12px', padding: '8px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                        <Text strong>ID:</Text> {record.id}<br />
                        <Text strong>Nhân viên:</Text> {record.name}<br />
                        <Text strong>Nội dung:</Text> {record.noi_dung}
                    </div>
                </div>
            ),
            okText: 'OK',
            okType: 'danger',
            cancelText: 'Hủy',
            onOk() {
                // Gọi hàm deleteJob với các tham số cần thiết
                deleteJob(record.id, record.user_id, record.device_token);
            },
            onCancel() {
                console.log('Cancel delete');
            },
        });
    };

    const formatTime = (timeStr) => {
        if (!timeStr) return '-';
        return dayjs(`2024-01-01 ${timeStr}`).format('HH:mm');
    };

    const getWorkDuration = (start) => {
        if (!start) return '-';

        const startTime = dayjs(`2024-01-01 ${start}`);
        const now = dayjs();
        const currentTime = dayjs(`2024-01-01 ${now.format('HH:mm:ss')}`);
        const duration = currentTime.diff(startTime, 'minute');

        if (duration < 60) {
            return `${duration} phút`;
        } else {
            const hours = Math.floor(duration / 60);
            const minutes = duration % 60;
            return `${hours}h ${minutes}p`;
        }
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 72,
            align: 'center',
            render: (id) => <Text strong style={{ fontSize: '14px' }}>{id}</Text>
        },
        {
            title: 'Nhân viên',
            dataIndex: 'name',
            key: 'name',
            width: 160,
            render: (name) => (
                <Text style={{ fontSize: '14px' }}>{name}</Text>
            )
        },
        {
            title: 'Trạng thái',
            key: 'status',
            width: 150,
            align: 'center',
            render: (_, record) => {
                if (record.start) {
                    return <Tag color="orange" icon={<PlayCircleOutlined />}>Đang thực hiện</Tag>;
                } else {
                    return <Tag color="red" icon={<StopOutlined />}>Chưa nhận việc</Tag>;
                }
            }
        },
        {
            title: 'Nội dung công việc',
            dataIndex: 'noi_dung',
            key: 'noi_dung',
            render: (content) => (
                <Text style={{ fontSize: '14px' }}>{content}</Text>
            )
        },
        {
            title: 'Bộ phận',
            dataIndex: 'department',
            key: 'department',
            width: 120,
            align: 'center',
            render: (department) => {
                let color = 'blue';
                if (department === 'Máy tính') color = 'blue';
                else if (department === 'Công trình') color = 'orange';
                else if (department === 'Dự án') color = 'green';
                else if (department === 'Photocopy') color = 'purple';

                return <Tag color={color}>{department}</Tag>;
            }
        },
        {
            title: 'Thời gian bắt đầu',
            dataIndex: 'start',
            key: 'start',
            width: 140,
            align: 'center',
            render: (start) => (
                <Text style={{ fontSize: '14px' }}>
                    <ClockCircleOutlined /> {formatTime(start)}
                </Text>
            )
        },
        {
            title: 'Thời gian làm việc',
            key: 'duration',
            width: 140,
            align: 'center',
            render: (_, record) => (
                <Text
                    strong
                    style={{
                        fontSize: '14px',
                        color: '#faad14'
                    }}
                >
                    {getWorkDuration(record.start)}
                </Text>
            )
        },
        {
            title: 'Hành động',
            key: 'actions',
            width: 140,
            align: 'center',
            fixed: 'right',
            render: (_, record) => (
                <Space size="small">
                    <Tooltip title="Xem vị trí">
                        <Button
                            type="primary"
                            icon={<EnvironmentOutlined />}
                            size="small"
                            onClick={() => handleViewLocation(record)}
                            style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                        />
                    </Tooltip>

                    <Tooltip title="Sửa công việc">
                        <Button
                            type="primary"
                            icon={<EditOutlined />}
                            size="small"
                            onClick={() => handleEditJob(record)}
                        />
                    </Tooltip>

                    <Tooltip title="Xóa công việc">
                        <Button
                            type="primary"
                            danger
                            icon={<DeleteOutlined />}
                            size="small"
                            onClick={() => handleDeleteJob(record)}
                        />
                    </Tooltip>
                </Space>
            )
        }
    ];

    // Auto load khi component mount và kết nối socket
    useEffect(() => {
        fetchViecDangLam();

        // Kết nối socket
        socketManager.connect();

        // Tự động load data mỗi 5 giây
        const interval = setInterval(() => {
            fetchViecDangLam();
        }, 20000);

        // Cleanup khi component unmount
        return () => {
            socketManager.disconnect();
            clearInterval(interval);
        };
    }, []);

    const loadLeafletMap = useCallback((lat, lng, name) => {
        try {
            // Kiểm tra xem Leaflet đã được load chưa
            if (typeof window !== 'undefined' && window.L) {
                // Xóa map cũ nếu có
                const mapContainer = document.getElementById('leaflet-map');
                if (mapContainer) {
                    mapContainer.innerHTML = '';

                    try {
                        // Tạo map mới
                        const map = window.L.map('leaflet-map').setView([lat, lng], 15);

                        // Thêm tile layer
                        window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                            attribution: '© OpenStreetMap contributors'
                        }).addTo(map);

                        // Thêm marker
                        window.L.marker([lat, lng])
                            .addTo(map)
                            .bindPopup(`<b>${name}</b><br>Vị trí công việc`)
                            .openPopup();

                        console.log('Leaflet map loaded successfully');
                    } catch (mapError) {
                        console.error('Error creating Leaflet map:', mapError);
                        showMapError(mapContainer);
                    }
                }
            } else {
                // Nếu chưa có Leaflet, load từ CDN
                loadLeafletFromCDN(lat, lng, name);
            }
        } catch (error) {
            console.error('Error in loadLeafletMap:', error);
            const mapContainer = document.getElementById('leaflet-map');
            if (mapContainer) {
                showMapError(mapContainer);
            }
        }
    }, []);

    // Load Leaflet map khi modal mở
    useEffect(() => {
        if (mapModalVisible && selectedLocation) {
            // Delay một chút để đảm bảo modal đã render
            setTimeout(() => {
                loadLeafletMap(selectedLocation.lat, selectedLocation.lng, selectedLocation.name);
            }, 300);
        }
    }, [mapModalVisible, selectedLocation, loadLeafletMap]);

    const loadLeafletFromCDN = (lat, lng, name) => {
        try {
            // Kiểm tra xem đã load CSS chưa
            const existingCSS = document.querySelector('link[href*="leaflet.css"]');
            if (!existingCSS) {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
                link.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';
                link.crossOrigin = '';
                document.head.appendChild(link);
            }

            // Kiểm tra xem đã load JS chưa
            const existingScript = document.querySelector('script[src*="leaflet.js"]');
            if (!existingScript) {
                const script = document.createElement('script');
                script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
                script.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
                script.crossOrigin = '';
                script.onload = () => {
                    console.log('Leaflet loaded from CDN');
                    setTimeout(() => {
                        loadLeafletMap(lat, lng, name);
                    }, 200);
                };
                script.onerror = () => {
                    console.error('Failed to load Leaflet from CDN');
                    const mapContainer = document.getElementById('leaflet-map');
                    if (mapContainer) {
                        showMapError(mapContainer);
                    }
                };
                document.head.appendChild(script);
            } else {
                // Script đã tồn tại, chờ load xong
                setTimeout(() => {
                    loadLeafletMap(lat, lng, name);
                }, 200);
            }
        } catch (error) {
            console.error('Error loading Leaflet from CDN:', error);
            const mapContainer = document.getElementById('leaflet-map');
            if (mapContainer) {
                showMapError(mapContainer);
            }
        }
    };

    const showMapError = (container) => {
        container.innerHTML = `
            <div style="
                display: flex; 
                flex-direction: column; 
                align-items: center; 
                justify-content: center; 
                height: 100%; 
                background-color: #f5f5f5; 
                border-radius: 6px;
                padding: 20px;
                text-align: center;
            ">
                <div style="font-size: 48px; margin-bottom: 16px;">🗺️</div>
                <div style="font-size: 16px; font-weight: bold; margin-bottom: 8px; color: #666;">
                    Không thể tải bản đồ
                </div>
                <div style="font-size: 14px; color: #999; margin-bottom: 16px;">
                    Vui lòng thử lại hoặc sử dụng Google Maps
                </div>
                <div style="font-size: 12px; color: #ccc;">
                    Tọa độ: ${selectedLocation?.lat}, ${selectedLocation?.lng}
                </div>
            </div>
        `;
    };

    return (
        <div>
            <style>
                {`
                    .in-progress-row {
                        background-color: #fff7e6 !important;
                    }
                    .in-progress-row:hover {
                        background-color: #ffe7ba !important;
                    }
                `}
            </style>

            <Card
                title="Danh sách công việc đang thực hiện - Bộ phận: Máy tính, Công trình, Dự án & Photocopy"
                style={{ marginBottom: '16px' }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '16px' }}>
                    <div>
                        <Text type="secondary" style={{ fontSize: '16px' }}>
                            Tổng {jobsData.length} công việc đang thực hiện (Máy tính, Công trình, Dự án, Photocopy)
                        </Text>
                    </div>

                    <Button
                        type="primary"
                        icon={<ReloadOutlined />}
                        onClick={fetchViecDangLam}
                        loading={loading}
                    >
                        Tải lại
                    </Button>
                </div>

                {loading ? (
                    <div style={{ textAlign: 'center', padding: '48px' }}>
                        <Text style={{ fontSize: '16px' }}>Đang tải dữ liệu...</Text>
                    </div>
                ) : (
                    <Table
                        columns={columns}
                        dataSource={jobsData}
                        rowKey="id"
                        pagination={false}
                        scroll={{ x: 1400, y: 600 }}
                        locale={{
                            emptyText: 'Không có công việc nào đang thực hiện trong bộ phận Máy tính, Công trình, Dự án và Photocopy'
                        }}
                        size="middle"
                        bordered
                        rowClassName={() => 'in-progress-row'}
                    />
                )}

                {/* Modal hiển thị bản đồ */}
                <Modal
                    title={`Vị trí công việc - ${selectedLocation?.name}`}
                    open={mapModalVisible}
                    onCancel={() => setMapModalVisible(false)}
                    footer={[
                        <Button key="close" onClick={() => setMapModalVisible(false)}>
                            Đóng
                        </Button>,
                        <Button
                            key="google"
                            type="primary"
                            onClick={() => {
                                if (selectedLocation) {
                                    const googleMapsUrl = `https://www.google.com/maps?q=${selectedLocation.lat},${selectedLocation.lng}`;
                                    window.open(googleMapsUrl, '_blank');
                                }
                            }}
                        >
                            Mở Google Maps
                        </Button>
                    ]}
                    width={800}
                    style={{ top: 20 }}
                >
                    {selectedLocation && (
                        <div>
                            <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
                                <Text strong style={{ display: 'block', marginBottom: '4px' }}>
                                    Công việc ID: {selectedLocation.jobId}
                                </Text>
                                <Text style={{ display: 'block', marginBottom: '4px' }}>
                                    Nhân viên: {selectedLocation.name}
                                </Text>
                                <Text style={{ display: 'block', marginBottom: '4px' }}>
                                    Nội dung: {selectedLocation.content}
                                </Text>
                                <Text type="secondary" style={{ fontSize: '12px' }}>
                                    Tọa độ: {selectedLocation.lat}, {selectedLocation.lng}
                                </Text>
                            </div>

                            {/* Leaflet Map Container */}
                            <div
                                id="leaflet-map"
                                style={{
                                    height: '400px',
                                    width: '100%',
                                    border: '1px solid #d9d9d9',
                                    borderRadius: '6px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#f5f5f5'
                                }}
                            >
                                <div style={{ textAlign: 'center', color: '#999' }}>
                                    <div style={{ fontSize: '24px', marginBottom: '8px' }}>🗺️</div>
                                    <div>Đang tải bản đồ...</div>
                                </div>
                            </div>

                            {/* Fallback nếu không load được Leaflet */}
                            <div style={{ marginTop: '12px', textAlign: 'center' }}>
                                <Text type="secondary" style={{ fontSize: '12px' }}>
                                    💡 Tip: Click "Mở Google Maps" để xem chi tiết hơn
                                </Text>
                            </div>
                        </div>
                    )}
                </Modal>

                {/* Modal sửa công việc */}
                <Modal
                    title="Sửa nội dung công việc"
                    open={editModalVisible}
                    onCancel={() => {
                        setEditModalVisible(false);
                        setSelectedJob(null);
                        setEditContent('');
                    }}
                    footer={[
                        <Button
                            key="cancel"
                            onClick={() => {
                                setEditModalVisible(false);
                                setSelectedJob(null);
                                setEditContent('');
                            }}
                        >
                            Hủy
                        </Button>,
                        <Button
                            key="save"
                            type="primary"
                            onClick={handleSaveEdit}
                            disabled={!editContent.trim()}
                        >
                            Xác nhận
                        </Button>
                    ]}
                    width={600}
                >
                    {selectedJob && (
                        <div>
                            <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
                                <Text strong style={{ display: 'block', marginBottom: '4px' }}>
                                    Thông tin công việc:
                                </Text>
                                <Text style={{ display: 'block', marginBottom: '4px' }}>
                                    <Text strong>ID:</Text> {selectedJob.id}
                                </Text>
                                <Text style={{ display: 'block', marginBottom: '4px' }}>
                                    <Text strong>Nhân viên:</Text> {selectedJob.name}
                                </Text>
                                <Text style={{ display: 'block', marginBottom: '4px' }}>
                                    <Text strong>Bộ phận:</Text> {selectedJob.department}
                                </Text>
                                <Text style={{ display: 'block' }}>
                                    <Text strong>Nội dung hiện tại:</Text> {selectedJob.noi_dung}
                                </Text>
                            </div>

                            <div>
                                <Text strong style={{ display: 'block', marginBottom: '8px' }}>
                                    Nội dung công việc mới: <span style={{ color: 'red' }}>*</span>
                                </Text>
                                <Input.TextArea
                                    value={editContent}
                                    onChange={(e) => setEditContent(e.target.value)}
                                    placeholder="Nhập nội dung công việc mới..."
                                    rows={4}
                                    maxLength={1000}
                                    showCount
                                    style={{ fontSize: '14px', marginBottom: 20 }}
                                />
                            </div>
                        </div>
                    )}
                </Modal>
            </Card>
        </div>
    );
};


export default ViecDangLamComponent;
